import { RPM_PATIENT_STATUS } from '../constants';

export const WORKLOG_PROGRAMS = Object.freeze(['RPM', 'RTM', 'CCM', 'PCM']);

export const getTimerPrograms = (patientPrograms, preActivationWorklogsEnabled) => (
  patientPrograms?.filter(program => (
    WORKLOG_PROGRAMS.includes(program.name)
    && (
      program.status === RPM_PATIENT_STATUS.activated
      || (preActivationWorklogsEnabled && program.status === RPM_PATIENT_STATUS.enrolled)
    )
  )) || []
);

// Enrollments a retroactive task (Task History "Add Task") may be added to.
// Wider than the live-timer list: the pre-activation org flag does not gate
// retroactive adds, so an "enrolled" enrollment qualifies regardless of it.
// A task's start time must still fall inside the enrollment's window, which
// starts at worklogWindowStart (the earlier of the scheduled start and the
// actual activation) - an enrollment without one was never "at least
// enrolled", and one whose window starts in the future cannot receive any task
// yet (tasks cannot be in the future either) (RXC-1603).
export const getRetroactiveAddPrograms = (patientPrograms, now = new Date()) => (
  patientPrograms?.filter(program => (
    WORKLOG_PROGRAMS.includes(program.name)
    && (
      program.status === RPM_PATIENT_STATUS.activated
      || program.status === RPM_PATIENT_STATUS.enrolled
    )
    && program.worklogWindowStart
    && new Date(program.worklogWindowStart) <= now
  )) || []
);
